import styled, { css } from 'styled-components';

export const VirtualizerContainer = styled.div<{ $isScrollable: boolean }>`
  ${({ $isScrollable }) =>
    $isScrollable &&
    css`
      width: 100%;
      height: 100%;
      overflow: auto;
    `}
`;

export const TreeContainer = styled.div<{ $height: number }>`
  position: relative;
  height: ${({ $height }) => $height}px;
  width: 100%;
`;

export const ItemContainer = styled.div<{
  $level: number;
  $denseFormat?: boolean;
  $indentationWidth?: number;
}>`
  position: absolute;
  top: 0;
  right: ${({ theme }) => theme.spacing(4.5)};
  left: ${({ theme, $level, $indentationWidth }) =>
    `calc(${theme.spacing(2.5)} + ${$level} * ${theme.spacing($indentationWidth ?? 2)})`};

  ${({ $denseFormat, theme, $level }) =>
    $denseFormat &&
    css`
      right: ${theme.spacing(2.5)};
      left: calc(${theme.spacing(0.5)} + ${$level} * ${theme.spacing(2)});
    `}

  pointer-events: none;
  & > * {
    pointer-events: auto;
  }
`;

export const DragLine = styled.div<{ $denseFormat?: boolean }>`
  height: ${({ theme }) => theme.spacing(0.5)};
  background: ${({ theme }) => theme.palette.primary.main};
  margin-left: ${({ theme }) => theme.spacing(2.5)};

  ${({ $denseFormat, theme }) =>
    $denseFormat &&
    css`
      margin-left: ${theme.spacing(2.5)};
    `}

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    display: block;

    height: ${({ theme }) => theme.spacing(2)};
    width: ${({ theme }) => theme.spacing(2)};
    background: ${({ theme }) => theme.palette.background.default};

    transform: translate(-50%, -50%);
    border: ${({ theme }) => `2px solid ${theme.palette.primary.main}`};
    border-radius: 50%;
  }
`;

export const DragPreviewContainer = styled.div`
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(2.5)};
  width: 400px;
  overflow: hidden;
  padding: ${({ theme }) => theme.spacing(1, 2)};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  font-family: ${({ theme }) => theme.typography.fontFamily};
`;

export const DragPreviewWrapper = styled.div`
  position: absolute;
  left: -10000px;
  top: -10000px;
`;
